import { Injectable } from "@angular/core";
import { takeUntil } from "rxjs";
import { DestroyService } from "@webapp/core/util/services/destroy.service";
import { PluginStateService } from "@webapp/plugins/components/plugin/services/plugin-state.service";
import { getPluginIFrameElement } from "@webapp/plugins/utils";

@Injectable({
  providedIn: "any",
})
export class PluginService {
  public plugin;
  public accessPoint;
  public item;
  public context;
  private pluginStateService;
  private destroy$;

  constructor(pluginStateService: PluginStateService, destroy$: DestroyService) {
    this.pluginStateService = pluginStateService;
    this.destroy$ = destroy$;

    this.pluginStateService
      .getPlugin$()
      .pipe(takeUntil(this.destroy$))
      .subscribe({ next: (plugin) => (this.plugin = plugin) });

    this.pluginStateService
      .getAccessPoint$()
      .pipe(takeUntil(this.destroy$))
      .subscribe({ next: (accessPoint) => (this.accessPoint = accessPoint) });

    this.pluginStateService
      .getItem$()
      .pipe(takeUntil(this.destroy$))
      .subscribe({ next: (item) => (this.item = item) });

    this.pluginStateService
      .getContext$()
      .pipe(takeUntil(this.destroy$))
      .subscribe({ next: (context) => (this.context = context) });
  }

  public postMessage(data: unknown, type: string): void {
    const iframeWindow = getPluginIFrameElement({ plugin: this.plugin, accessPoint: this.accessPoint });
    try {
      iframeWindow.contentWindow.postMessage(
        {
          type,
          data,
        },
        this.plugin.uiPlugin.src
      );
    } catch (e) {
      console.warn(e);
    }
  }
}
